import { HttpClient } from '../../httpClient'
import type {
  ReadContentVersionAnnotationDocument,
  UpdateContentVersionAnnotationBody,
} from './types'

/**
 * Resolves or unresolves a pin annotation. A pin's position and comment are
 * immutable once placed, so this is the only update the API accepts.
 */
export const updateContentVersionAnnotation = async ({
  id,
  resolved,
}: {
  id: string
  resolved: boolean
}): Promise<ReadContentVersionAnnotationDocument> => {
  const url = new URL(
    `/v3/content_version_annotations/${id}`,
    window.location.origin
  )
  const body: UpdateContentVersionAnnotationBody = {
    data: {
      id,
      type: 'content_version_annotation',
      attributes: { resolved },
    },
  }

  return HttpClient()
    .patch(url.toString(), body)
    .then((res) => res.data)
}
